import { useState } from 'react';
import { FormField, FormSelect } from '@practium/ui';
import { PARAM_LABELS, PLAN_NUTRIENTS } from '../../constants/parameters.constants';
import type { RangeRow, RangesKind } from '../../types/parameters.types';
import { ValueInput } from '../Forms/ValueInput';
import styles from './Sections.module.css';

interface RangeValuesFieldsProps {
	kind: RangesKind;
	rows: RangeRow[];
	onChange: (rowIndex: number, valueIndex: number, value: number | undefined) => void;
}

const NUMERATOR_OPTIONS = PLAN_NUTRIENTS.map((nutrient) => ({ value: nutrient, label: PARAM_LABELS[nutrient] ?? nutrient }));

const FOLIAR_HEADERS = ['Limite 1', 'Limite 2', 'Limite 3', 'Limite 4'];
const DRIS_HEADERS = ['Média', 'Desvio padrão'];

export const RangeValuesFields = ({ kind, rows, onChange }: RangeValuesFieldsProps) => {
	const [numerator, setNumerator] = useState<string>(PLAN_NUTRIENTS[0]);
	const headers = kind === 'foliar' ? FOLIAR_HEADERS : DRIS_HEADERS;
	const visibleRows = rows
		.map((row, index) => ({ row, index }))
		.filter(({ row }) => kind === 'foliar' || row.code.startsWith(`${numerator}_`));

	return (
		<>
			{kind === 'dris' && (
				<FormField label="Relações do nutriente">
					<FormSelect value={numerator} options={NUMERATOR_OPTIONS} onChange={setNumerator} />
				</FormField>
			)}
			<div className={`${styles.rangeGrid} ${kind === 'foliar' ? styles.rangeGridFoliar : styles.rangeGridDris}`}>
				<span className={styles.classHeader}>{kind === 'foliar' ? 'Nutriente' : 'Relação'}</span>
				{headers.map((header) => (
					<span key={header} className={styles.classHeader}>
						{header}
					</span>
				))}
				{visibleRows.map(({ row, index }) => {
					const name = kind === 'foliar' ? (PARAM_LABELS[row.code] ?? row.code) : row.code.replace('_', ' / ');
					return (
						<div key={row.code} className={styles.rangeRow}>
							<span className={styles.rowLabel}>{name}</span>
							{row.values.map((value, valueIndex) => (
								<ValueInput
									key={valueIndex}
									label={`${name} - ${headers[valueIndex]}`}
									value={value}
									onChange={(next) => onChange(index, valueIndex, next)}
								/>
							))}
						</div>
					);
				})}
			</div>
		</>
	);
};
